<div [ngClass]="nameApp">
    <router-outlet></router-outlet>
</div>